import { TranslateService } from "@ngx-translate/core";
var SwitchRendererComponent = /** @class */ (function () {
    function SwitchRendererComponent(_translate) {
        this._translate = _translate;
        this.disabled = false;
    }
    SwitchRendererComponent.prototype.agInit = function (params) {
        this.params = params;
        this.disabled = this.params.disabled;
        var dagSource = this.params.data.dagSource;
        if (!this.params.disabled) {
            if (!dagSource) {
                dagSource = [];
            }
            else {
                var $_dagSource = JSON.parse(dagSource);
                dagSource = $_dagSource['endBlocks'];
            }
            this.params.disabled = dagSource.length == 0;
        }
        this.params.status = this.params.data.status != 0;
        this.statusActivationConfirmation = {
            modalType: 'confirm',
            actionText: 'ACTIVATE',
            confirmBtnType: 'DEFAULT',
            confirmBtnText: "ACTIVATE",
            confirmBxValidationMsg: '',
            itemText: "Automation",
            showModal: false,
            closeText: 'Close',
            message: {
                warningTxt: this._translate.instant('Automation.Confirm.Status.Activation.Message', {
                    automationName: this.params.data['name']
                }),
                helpTxtList: ['Activate.Now.Or.Save.As.Draft']
            },
            title: 'Confirm.Activation',
            doAction: this.onChangeCallback.bind(this),
            actionArg: '',
        };
    };
    SwitchRendererComponent.prototype.refresh = function (params) {
        return true;
    };
    SwitchRendererComponent.prototype.onChangeCallback = function (currentStatus, cb) {
        if (this.params.onChangeCallback) {
            this.params.onChangeCallback(currentStatus, cb, this);
        }
    };
    SwitchRendererComponent.prototype.onChangeStatusConfirmation = function () {
        var message = {};
        if (this.params.status) {
            message['warningTxt'] = this._translate.instant('Automation.Confirm.Status.Activation.Message', {
                automationName: this.params.data['name']
            });
            message['helpTxtList'] = [];
        }
        else {
            message['warningTxt'] = this._translate.instant('Automation.Confirm.Status.Deactivation.Message', {
                automationName: this.params.data['name']
            });
            message['helpTxtList'] = ['Custom.Automation.Deactivate.Message'];
        }
        var confirmBxValidationMsg = this.params.status ? this._translate.instant('confirmation.warning.text', { word: 'ACTIVATE', message: 'activate the automation' }) :
            this._translate.instant('confirmation.warning.text', { word: 'DEACTIVATE', message: 'deactivate the automation' });
        this.statusActivationConfirmation.actionArg = this.params.status;
        this.statusActivationConfirmation.confirmBxValidationMsg = confirmBxValidationMsg;
        this.statusActivationConfirmation.message = message;
        this.statusActivationConfirmation.showModal = true;
        this.statusActivationConfirmation.confirmBtnText = this.params.status ? "ACTIVATE" : "DEACTIVATE";
        this.statusActivationConfirmation.title = this.params.status ? 'Confirm.Activation' : 'Confirm.Deactivation';
        this.statusActivationConfirmation.actionText = this.params.status ? 'ACTIVATE' : 'DEACTIVATE';
    };
    SwitchRendererComponent.prototype.onCloseConfirmation = function (isCloseBtn, type) {
        if (type == 'activate') {
            if (isCloseBtn == 'CANCEL_BTN' || isCloseBtn == 'CLOSE_ICON')
                this.params.status = !this.params.status;
            this.statusActivationConfirmation.showModal = false;
        }
    };
    return SwitchRendererComponent;
}());
export { SwitchRendererComponent };
